import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import querystring from "query-string";
import { saveUser, saveIdToken, saveClient } from "../../utils/storage";
import { signin } from "../../services/authNew";
import { fetchClients } from "../../services/dashboard-api";

import DummyButton from "../DummyButton";

const Login = (props) => {
  const { setToast } = props;
  // const history = useHistory();
  const location = useLocation();

  const retUrl = querystring.parse(location.search).ret;

  const [loginData, setLoginData] = useState({
    identifier: "",
    password: "",
  });
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isLoginBusy, setIsLoginBusy] = useState(false);

  const toggleIsLoginBusy = () => setIsLoginBusy((isLoginBusy) => !isLoginBusy);

  const handleChange = (event) => {
    event.preventDefault();
    if (event.target.name === "identifier")
      validateEmail(event.target.value.trim());
    setLoginData({
      ...loginData,
      [event.target.name]: event.target.value.trim(),
    });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   // Make sure browser is online
  //   if (!window.navigator.onLine) {
  //     return setToast({
  //       show: true,
  //       type: "warning",
  //       message: "Looks like you are offline",
  //     });
  //   }

  //   toggleIsLoginBusy();

  //   // setToast({
  //   //   show: true,
  //   //   type: "processing",
  //   //   message: "Hold on while we try to get you inside..."
  //   // });
  //   // Login user on submission of email and password

  //   console.log("loginData", loginData);

  //   await signin(
  //     loginData
  //   ).then((response) => {
  //     console.log("response", response);
  //     //get user id token for server auth verification

  //     // console.log('user after idtoken', user);
  //     saveIdToken(response?.data.token);

  //     // Save user in localstorage
  //     saveUser(response?.data.user);
  //     // console.log('Login * logged in user');
  //     //clear the session storage data, this will enable the pop ups to show at every login
  //     sessionStorage.clear();
  //     // Get user plan
  //     fetchClients()
  //       .then(({ data }) => {
  //         console.log(data?.clients[0]);
  //         saveClient(data?.clients[0]);
  //         if (data?.clients[0].smeSetupStage
  //           === 1) {
  //           // client has only completed signup, redirect to subscribe to plan
  //           window.location.href = `${retUrl || "/subscribe"}`;
  //         } else {
  //           // client has completed steps beyond singup. He has paid for subscription
  //           // and probably completed other steps. Check if the client has onboarded.
  //           if (data?.clients[0].isOnboarded === false) {
  //             window.location.href = `${retUrl || `/onboarding?token=${data?.clients[0].onboardingToken}`
  //               }`;
  //           } else {
  //             // client has onboarded
  //             if (data?.clients[0].isOnboarded === true) {
  //               // history.push(`${retUrl || "/dashboard/listen"}`);
  //               window.location.href = `${retUrl || "/dashboard/listen"}`;
  //             } else {
  //               // history.push(`${retUrl || "/dashboard/ask"}`);
  //               window.location.href = `${retUrl || "/dashboard/ask"}`;
  //             }
  //           }
  //         }
  //         toggleIsLoginBusy();

  //       })
  //       .catch((error) => {
  //         console.log("error getting client", error);
  //         setToast({
  //           show: true,
  //           type: "warning",
  //           message:
  //             error.message ||
  //             "Oops! For some reason we couldn't get through",
  //         });
  //         toggleIsLoginBusy();
  //       });

  //   }).catch((error) => {
  //     console.log("error getting client", error);
  //     setToast({
  //       show: true,
  //       type: "warning",
  //       message:
  //         error.message ||
  //         "Oops! For some reason we couldn't get through",
  //     });

  //   });
  //   toggleIsLoginBusy();
  //   return;
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!window.navigator.onLine) {
      return setToast({
        show: true,
        type: "warning",
        message: "Looks like you are offline",
      });
    }

    toggleIsLoginBusy();

    try {
      const response = await signin(loginData);

      const token = response?.data?.token;
      const user = response?.data;

      console.log(response);

      if (!token || !user) {
        throw new Error("Invalid login response. No token or user found.");
      }

      saveIdToken(token);
      saveUser(user);
      sessionStorage.clear();

      // const { data } = await fetchClients();

      // console.log("Fetched client data:", data);

      // const client = data?.clients?.[0];
      // console.log(client);
      if (!user) throw new Error("User data not found.");

      saveClient(user);

      // if (client.smeSetupStage === 2) {
      //   window.location.href = retUrl || "/subscribe";
      // } else if (!client.isOnboarded) {
      //   window.location.href =
      //     retUrl || `/onboarding?token=${client.onboardingToken}`;
      // } else {
      //   window.location.href = retUrl || "/dashboard/listen";
      // }

      window.location.href = retUrl || "/dashboard/ask";
    } catch (error) {
      console.error("Login or client fetch failed", error);
      setToast({
        show: true,
        type: "warning",
        message: error.message || "Oops! Something went wrong",
      });
    } finally {
      toggleIsLoginBusy();
    }
  };

  const validateEmail = (identifier) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier)
      ? setIsEmailValid(true)
      : setIsEmailValid(false);

  return (
    <div>
      <p className="with-icon positive bottom-breather">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-lock icon push-left"
        >
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>{" "}
        We use 128-bit encryption. Your details are safe.
      </p>
      <div className="form-block w-form">
        <div>
          <div className="control">
            <label>Email</label>
            <input
              type="text"
              className="input large w-input"
              maxLength="256"
              name="identifier"
              onChange={handleChange}
              required=""
            />
          </div>
          <div className="control">
            <label>Password</label>
            <input
              type="password"
              className="input large w-input"
              maxLength="256"
              name="password"
              onChange={handleChange}
              required=""
            />
          </div>
          <div>
            Forgot your password?{" "}
            <Link to="/forgot-password">Send a reset mail.</Link>
          </div>
          {isLoginBusy ? (
            <DummyButton
              text="Logging you in..."
              extraClass="button large wide"
            />
          ) : (
            <button
              className={`button primary large wide ${
                isEmailValid && loginData.password ? "" : "is-disabled"
              }`}
              onClick={handleSubmit}
            >
              Log in
            </button>
          )}

          <div>
            {/* Don’t have an account? <Link to="/signup">Request a demo.</Link> */}
            Don’t have an account? <Link to="/signup">Sign up.</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
